import React from 'react'
import { Link } from 'react-router-dom'
import CruiseBooking from './CruiseBooking'
import EventBooking from './EventBooking'

class PortAdminAllBookings extends React.Component {
  state = {
    type: 'CRUISE',
  }

  componentDidMount = () => {
    let type = this.props.match.params.type || 'CRUISE'

    this.setState({
      type,
    })
  }

  handleChange = (event) => {
    this.setState(
      {
        [event?.target?.name]: event?.target?.value,
      },
      () => {
        window.location.href = `#/port-bookings/${this.state.type}`
      }
    )
  }

  render() {
    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div
                      className="d-inline"
                      style={{ width: 300 }}
                    >
                      <h4>Booking List</h4>
                    </div>
                    <select
                      name="type"
                      className="form-control m-l-30"
                      value={this.state.type}
                      onChange={this.handleChange}
                    >
                      <option value={'CRUISE'}>CRUISE</option>
                      <option value={'EVENT'}>EVENT</option>
                    </select>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Booking List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {this.state.type === 'CRUISE' && <CruiseBooking></CruiseBooking>}
            {this.state.type === 'EVENT' && <EventBooking></EventBooking>}
          </div>
        </div>
      </div>
    )
  }
}

export default PortAdminAllBookings
